"use client";
import { Menu as e, MenuContext as r } from "@ark-ui/react";
import { menu as i } from "@huspy/styled-system/recipes";
import { createStyleContext as n } from "../../utils/createStyleContext.mjs";
const { withRootProvider: a, withContext: t } = n(i), m = a(e.Root), p = t(
  e.Arrow,
  "arrow"
), I = t(
  e.ArrowTip,
  "arrowTip"
), s = t(
  e.CheckboxItem,
  "item"
), c = t(
  e.Content,
  "content"
), u = t(e.ContextTrigger, "contextTrigger"), d = t(
  e.Indicator,
  "indicator"
), g = t(e.ItemGroupLabel, "itemGroupLabel"), l = t(
  e.ItemGroup,
  "itemGroup"
), T = t(e.ItemIndicator, "itemIndicator"), M = t(
  e.Item,
  "item"
), x = t(
  e.ItemText,
  "itemText"
), y = t(
  e.Positioner,
  "positioner"
), N = t(e.RadioItemGroup, "itemGroup"), C = t(
  e.RadioItem,
  "item"
), G = t(
  e.Separator,
  "separator"
), w = t(
  e.TriggerItem,
  "triggerItem"
), R = t(
  e.Trigger,
  "trigger"
), o = {
  Context: r,
  Root: m,
  Arrow: p,
  ArrowTip: I,
  CheckboxItem: s,
  Content: c,
  ContextTrigger: u,
  Indicator: d,
  ItemGroupLabel: g,
  ItemGroup: l,
  ItemIndicator: T,
  Item: M,
  ItemText: x,
  Positioner: y,
  RadioItemGroup: N,
  RadioItem: C,
  Separator: G,
  TriggerItem: w,
  Trigger: R
};
o.Arrow.displayName = "MenuArrow";
o.ArrowTip.displayName = "MenuArrowTip";
o.CheckboxItem.displayName = "MenuCheckboxItem";
o.Content.displayName = "MenuContent";
o.ContextTrigger.displayName = "MenuContextTrigger";
o.Indicator.displayName = "MenuIndicator";
o.ItemGroupLabel.displayName = "MenuItemGroupLabel";
o.ItemGroup.displayName = "MenuItemGroup";
o.ItemIndicator.displayName = "MenuItemIndicator";
o.Item.displayName = "MenuItem";
o.ItemText.displayName = "MenuItemText";
o.Positioner.displayName = "MenuPositioner";
o.RadioItemGroup.displayName = "MenuRadioItemGroup";
o.RadioItem.displayName = "MenuRadioItem";
o.Separator.displayName = "MenuSeparator";
o.TriggerItem.displayName = "MenuTriggerItem";
o.Trigger.displayName = "MenuTrigger";
export {
  o as Menu
};
